/**
 * Creates a object for every .Users DOM element.
 */
common.View.create('static admin::user.Permissions', {

    checkedPerms: [],

    toggle()
    {
        this.checkedPerms = this.permissions ? this.checkedPerms = [] : this.checkedPerms = this.permissions
    },

});
